import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UserFavViewModal = ({ isOpen, onClose, item, language, onDelete }) => {
  if (!isOpen || !item) return null;

  const listing = item.listing;
  const user = item.user;

  const labels = {
    title: { en: 'Car Profile Details', ar: 'تفاصيل ملف السيارة' },
    owner: { en: 'Owner', ar: 'المالك' },
    brand: { en: 'Car Brand', ar: 'ماركة السيارة' },
    model: { en: 'Model', ar: 'الموديل' },
    year: { en: 'Year', ar: 'السنة' },
    color: { en: 'Color', ar: 'اللون' },
    fuel: { en: 'Fuel Type', ar: 'نوع الوقود' },
    gear: { en: 'Gear Type', ar: 'ناقل الحركة' },
    carStatus: { en: 'Status', ar: 'الحالة' },
    area: { en: 'Area', ar: 'المنطقة' },
    distance: { en: 'Distance Driven', ar: 'المسافة المقطوعة' },
    price: { en: 'Price', ar: 'السعر' },
    description: { en: 'Description', ar: 'الوصف' },
    views: { en: 'Views', ar: 'عدد المشاهدات' },
    userInfo: { en: 'User Information', ar: 'معلومات المستخدم' },
    fullName: { en: 'Full Name', ar: 'الاسم الكامل' },
    phone: { en: 'Phone Number', ar: 'رقم الهاتف' },
    birthday: { en: 'Birthday', ar: 'تاريخ الميلاد' },
    role: { en: 'Role', ar: 'الدور' },
    verified: { en: 'Verified', ar: 'تم التحقق' },
    delete: { en: 'Delete', ar: 'حذف' },
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center p-4">
      <div className="bg-card rounded-xl shadow-elevation-4 border border-border w-full max-w-3xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="border-b border-border px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-foreground">
            {labels.title[language]}
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted transition-smooth"
            aria-label="Close"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 space-y-6 text-sm">
          {/* User Information */}
          <div>
            <h3 className="font-semibold text-foreground mb-2">{labels.userInfo[language]}</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="font-medium text-text-secondary">{labels.fullName[language]}</label>
                <p className="mt-1 text-foreground">{user?.first_name} {user?.last_name}</p>
              </div>
              <div>
                <label className="font-medium text-text-secondary">{labels.phone[language]}</label>
                <p className="mt-1 text-foreground">{user?.phone_number}</p>
              </div>
              <div>
                <label className="font-medium text-text-secondary">{labels.birthday[language]}</label>
                <p className="mt-1 text-foreground">{user?.birthday}</p>
              </div>
              <div>
                <label className="font-medium text-text-secondary">{labels.role[language]}</label>
                <p className="mt-1 text-foreground">{user?.role}</p>
              </div>
              <div>
                <label className="font-medium text-text-secondary">{labels.verified[language]}</label>
                <p className="mt-1 text-foreground">{user?.is_verified ? '✅' : '❌'}</p>
              </div>
            </div>
          </div>

          {/* Car Information */}
          <div>
            <h3 className="font-semibold text-foreground mb-2">{labels.title[language]}</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="font-medium text-text-secondary">{labels.owner[language]}</label>
                <p className="mt-1 text-foreground">{listing?.owner}</p>
              </div>
              <div>
                <label className="font-medium text-text-secondary">{labels.brand[language]}</label>
                <p className="mt-1 text-foreground">{listing?.car_brand?.name}</p>
              </div>
              <div>
                <label className="font-medium text-text-secondary">{labels.model[language]}</label>
                <p className="mt-1 text-foreground">{listing?.car_model}</p>
              </div>
              <div>
                <label className="font-medium text-text-secondary">{labels.year[language]}</label>
                <p className="mt-1 text-foreground">{listing?.car_year}</p>
              </div>
              <div>
                <label className="font-medium text-text-secondary">{labels.color[language]}</label>
                <p className="mt-1 text-foreground">{listing?.color?.name}</p>
              </div>
              <div>
                <label className="font-medium text-text-secondary">{labels.fuel[language]}</label>
                <p className="mt-1 text-foreground">{listing?.fuel_type?.name}</p>
              </div>
              <div>
                <label className="font-medium text-text-secondary">{labels.gear[language]}</label>
                <p className="mt-1 text-foreground">{listing?.gear_type?.name}</p>
              </div>
              <div>
                <label className="font-medium text-text-secondary">{labels.carStatus[language]}</label>
                <p className="mt-1 text-foreground">{listing?.car_status}</p>
              </div>
              <div>
                <label className="font-medium text-text-secondary">{labels.area[language]}</label>
                <p className="mt-1 text-foreground">{listing?.area?.area_name}</p>
              </div>
              <div>
                <label className="font-medium text-text-secondary">{labels.distance[language]}</label>
                <p className="mt-1 text-foreground">{listing?.distance_driven} km</p>
              </div>
              <div>
                <label className="font-medium text-text-secondary">{labels.price[language]}</label>
                <p className="mt-1 text-foreground">{listing?.price} IQD</p>
              </div>
              <div>
                <label className="font-medium text-text-secondary">{labels.views[language]}</label>
                <p className="mt-1 text-foreground">{listing?.views_counter}</p>
              </div>
              <div className="sm:col-span-2">
                <label className="font-medium text-text-secondary">{labels.description[language]}</label>
                <p className="mt-1 text-foreground">{listing?.description}</p>
              </div>
            </div>
          </div>

          {/* Delete Button */}
          <div className="flex gap-3 pt-4">
            <Button
              variant="destructive"
              fullWidth
              onClick={onDelete}
              iconName="Trash2"
            >
              {labels.delete[language]}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserFavViewModal;